import request from '@/utils/request'

function post({
  url = '',
  data = null,
  showLoading = true,
  beforeConfirm = true
}) {
  return request({
    url: url,
    method: 'post',
    data: data,
    showLoading: showLoading,
    beforeConfirm: beforeConfirm
  })
}

function put({ url = '', data = null, token, showLoading = true, beforeConfirm = true }) {
  return request({
    url: url,
    method: 'put',
    data: data,
    showLoading: showLoading,
    beforeConfirm: beforeConfirm,
    headers: {
      Authorization: token
    }
  })
}

function get({ url = '', data = null, showLoading = true }) {
  return request({
    url: url,
    method: 'get',
    params: data,
    showLoading: showLoading
  })
}

export default {
  post,
  get,
  put
}